import { TexturesStorage } from '../../../factories/TexturesStorage';
import { MaterialsFactory } from '../../../factories/MaterialsFactory';
import { UNIT } from '../../../../../constants/size';

const THREE = require('three');

export const getArrowButton = async () => {
    const width = 160 * UNIT.sizesScaleRatio;
    const height = 100 * UNIT.sizesScaleRatio;
    const geom = new THREE.PlaneBufferGeometry(width, height);

    const texture = await TexturesStorage.getTexture({
        options: [
            {
                type: 'image',
                src: 'assets/images/textures/arrow-right.png',
                ratio: 1
            }
        ]
    }, 'arrow');

    const root = new THREE.Group();
    const view = new THREE.Group();
    const mesh = new THREE.Mesh(geom, MaterialsFactory.create({
        map: texture,
        transparent: true
    }));
    const hitArea = new THREE.Mesh(geom, MaterialsFactory.create({
        opacity: 0,
        transparent: true
    }));

    root.width = width;
    root.height = height;
    root.mesh = mesh;
    root.view = view;
    root.hitArea = hitArea;

    view.add(mesh);
    root.add(view);
    root.add(hitArea);

    return root;
};
